<!-- eslint-disable -->
<template>
  <span class="info-tooltip">
    <Tooltip ref="tooltip" :autoHide="true" :triggers="['click']" placement="bottom-end">
      <div class="info-tooltip__trigger"></div>
      <template #popper>
        <a class="info-tooltip__hide" @click.prevent="onHideClick"></a>
        <div class="info-tooltip__content" v-html="content" />
      </template>
    </Tooltip>
  </span>
</template>

<script src="./InfoTooltip.js"></script>
<!-- eslint-enable -->
